import {
  SR_API_ACTION_RENTLINX_LEAD_GET_BY_PHONE,
} from 'api/actionTypes';

export default async function getByPhone(
  { state, apiClient },
  { phone },
) {
  const rentlinxLead = await apiClient.postWithState({
    action: SR_API_ACTION_RENTLINX_LEAD_GET_BY_PHONE,
    state: state,
    payload: {
      phone,
    },
  });

  return rentlinxLead;
}
